import API from "../config/Api";

export const supportsWebPush = () => typeof window !== "undefined"
    && "serviceWorker" in navigator
    && "PushManager" in window
    && "Notification" in window;

export const urlBase64ToUint8Array = (value) => {
    const padding = "=".repeat((4 - (value.length % 4)) % 4);
    const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
    const raw = window.atob(base64);
    return Uint8Array.from([...raw].map((character) => character.charCodeAt(0)));
};

export const deviceLabel = () => {
    const platform = navigator.userAgentData?.platform || navigator.platform || "Appareil";
    const standalone = window.matchMedia?.("(display-mode: standalone)")?.matches ? "Application" : "Navigateur";
    return `${standalone} - ${platform}`.slice(0, 160);
};

export const serializeSubscription = (subscription) => {
    const value = subscription.toJSON();
    return {
        endpoint: value.endpoint,
        keys: value.keys,
        deviceLabel: deviceLabel(),
    };
};

export const getPushSubscription = async () => {
    if (!supportsWebPush()) return null;
    const registration = await navigator.serviceWorker.getRegistration();
    return registration ? registration.pushManager.getSubscription() : null;
};

export const registerExistingPushSubscription = async () => {
    const subscription = await getPushSubscription();
    if (!subscription) return null;
    await API.post("/notifications/push/subscriptions", serializeSubscription(subscription));
    return subscription;
};

export const enablePushSubscription = async (applicationServerKey) => {
    if (!supportsWebPush()) throw new Error("Ce navigateur ne prend pas en charge les notifications système.");
    const permission = await window.Notification.requestPermission();
    if (permission !== "granted") throw new Error("Les notifications sont bloquees dans le navigateur.");

    const registration = await navigator.serviceWorker.ready;
    let subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
        subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(applicationServerKey),
        });
    }
    await API.post("/notifications/push/subscriptions", serializeSubscription(subscription));
    return subscription;
};

export const unregisterCurrentPushSubscription = async () => {
    try {
        const subscription = await getPushSubscription();
        if (!subscription) return;
        try {
            await API.post("/notifications/push/unsubscribe", { endpoint: subscription.endpoint }, { timeout: 1800 });
        } finally {
            await subscription.unsubscribe();
        }
    } catch (error) {
        // Logging out must remain available if the push provider is offline.
    }
};
